/**
 * SubformulaExpressionSnippet — one-line read-only formula preview in the card header
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

export interface SubformulaExpressionSnippetProps {
  expression: string;
}

function summary(raw: string): { text: string; isEmpty: boolean } {
  const t = raw.trim();
  if (!t) return { text: 'No expression yet', isEmpty: true };
  return { text: t, isEmpty: false };
}

const SubformulaExpressionSnippet: FC<SubformulaExpressionSnippetProps> = ({ expression }) => {
  const { text, isEmpty } = summary(expression);
  return (
    <div
      className="flex min-h-8 min-w-0 items-center overflow-hidden rounded-md border border-border/60 bg-muted/35 px-2.5"
      title={isEmpty ? undefined : expression.trim()}
    >
      <span
        className={`truncate font-mono text-xs tabular-nums leading-snug ${
          isEmpty ? 'italic text-muted-foreground' : 'text-foreground'
        }`}
      >
        {text}
      </span>
    </div>
  );
};

export default SubformulaExpressionSnippet;
